// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3yf-B","noInteraction":"EventWrapper_noInteraction__3vPf1"};